import { Select } from 'antd';
import { useAppDispatch } from 'app/hooks';
import { IMG_ALT, KEY_LANGUAGE_LOCALSTORAGE } from 'consts/app';
import React, { useMemo } from 'react';
import { LanguageEnum, changeLanguage } from 'redux/userSlice';
import { getLocalStorage, setLocalStorage } from 'utils/sessionStorage';
import english from 'assets/icons/languages/english.png';
import chinese from 'assets/icons/languages/china.png';
import cambodia from 'assets/icons/languages/combodia.png';
import thai from 'assets/icons/languages/thai.png';
import spanish from 'assets/icons/languages/spain.png';
import french from 'assets/icons/languages/france.png';
import russia from 'assets/icons/languages/russia.png';
import turkey from 'assets/icons/languages/turkey.png';
import { getLanguageKey } from 'hooks/useMultiLanguage';

const { Option } = Select;

interface LanguageDropdownProps {}

const languageOptions = [
  {
    value: LanguageEnum.ENGLISH,
    image: english,
    label: 'English',
  },
  {
    value: LanguageEnum.CHINESE,
    image: chinese,
    label: '中国人',
  },
  {
    value: LanguageEnum.FRENCH,
    image: french,
    label: 'Français',
  },
  {
    value: LanguageEnum.SPANISH,
    image: spanish,
    label: 'Española',
  },
  {
    value: LanguageEnum.THAI,
    image: thai,
    label: 'แบบไทย',
  },
  {
    value: LanguageEnum.CAMBODIA,
    image: cambodia,
    label: 'កម្ពុជា',
  },
  {
    value: LanguageEnum.TURKEY,
    image: turkey,
    label: 'Türkçe',
  },
  {
    value: LanguageEnum.RUSSIA,
    image: russia,
    label: 'РОССИЯ',
  },
];

const LanguageDropdown: React.FunctionComponent<LanguageDropdownProps> = () => {
  const dispatch = useAppDispatch();

  const defaultLanguage = useMemo(() => {
    return getLanguageKey(getLocalStorage(KEY_LANGUAGE_LOCALSTORAGE) || '');
  }, []);

  const handleChangeLanguage = (value: LanguageEnum) => {
    dispatch(changeLanguage(value));
    setLocalStorage(KEY_LANGUAGE_LOCALSTORAGE, value);
  };

  return (
    <Select
      className="languages-dropdown primary-text-color"
      dropdownClassName="language-items primary-text-color"
      defaultValue={defaultLanguage}
      onChange={handleChangeLanguage}
      optionLabelProp="label"
      placement="bottomRight"
    >
      {languageOptions.map((option) => (
        <Option
          key={option.value}
          value={option.value}
          label={<img className="w-5 h-5" src={option.image} alt={IMG_ALT} />}
        >
          <div className="flex-row items-center gap-1 p-1">
            <img className="w-5 h-5" src={option.image} alt={IMG_ALT} />
            <span>{option.label}</span>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default LanguageDropdown;
